import * as React from 'react'

export const SvgAccountDetailsOutline = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M22 5v14H2V5h20zm-2 2H4v10h16V7zm-1 7v1.5h-6V14h6zM8.405 12.851c1.881 0 3.406 1.186 3.406 2.649H5c0-1.463 1.525-2.649 3.405-2.649zM19 11.25v1.5h-6v-1.5h6zM8.405 8.5a1.892 1.892 0 110 3.784 1.892 1.892 0 010-3.784zM17 8.5V10h-4V8.5h4z" />
  </svg>
)
export default SvgAccountDetailsOutline
